var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'core', 'app-common/component/api-call', 'app-common/component/service-call', 'app-common/component/confirm-dialog', 'app-common/data/events.json', 'common/location', 'date-fns'], function($, _, Backbone, core, apiCall, serviceCall, confirmDialog, eventsRaw, location, dateFns) {
  var ClientsEventsView, eventsMetadata;
  eventsMetadata = eventsRaw;
  return ClientsEventsView = (function(_super) {
    var monthNumericToText;

    __extends(ClientsEventsView, _super);

    function ClientsEventsView() {
      ClientsEventsView.__super__.constructor.apply(this, arguments);
    }

    ClientsEventsView.prototype.sanitize = function(text) {
      return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    };

    ClientsEventsView.prototype.findClientDataById = function(clientId) {
      throw new Error('Not implemented');
    };

    ClientsEventsView.prototype.getFiltering = function() {};

    ClientsEventsView.prototype.events = {
      'click .remove-clients-event': 'removeEvent',
      'click .remove-group-clients-events': 'removeGroupEventsForSingleClient'
    };

    ClientsEventsView.prototype._removeGroupEvents = function(e, otherParams) {
      var count, element, name,
        _this = this;
      element = $(e.currentTarget).closest('.clients-event-group');
      name = element.data('group-name');
      count = this.getCounterValue(name);
      confirmDialog.init("Are you sure you want to delete all " + count + " events in this group?", {
        ok: 'Delete All Events',
        cancel: 'Never Mind'
      });
      return $('.confirm-ok').on('click', function() {
        var params, promise;
        params = _.extend(otherParams, _this._extraParams(), {
          names: name
        });
        promise = serviceCall('nodeway', "notifications/" + (core.getCurrentUserid()), 'DELETE', params);
        promise.done(function() {
          return _this.trigger('event.group:removed', element, {
            name: name,
            count: count
          });
        });
        return confirmDialog.hide();
      });
    };

    ClientsEventsView.prototype.removeGroupEventsForSingleClient = function(e) {
      return this._removeGroupEvents(e, {
        cids: core.getCurrentClientId()
      });
    };

    ClientsEventsView.prototype.removeGroupEventsForFilters = function(e) {
      var filters;
      filters = _.extend(this.getFiltering(), {
        useFilters: true
      });
      return this._removeGroupEvents(e, filters);
    };

    ClientsEventsView.prototype.removeEvent = function(e) {
      var count, element, id, ids, name, params, promise, promises,
        _this = this;
      element = $(e.currentTarget).closest('.clients-event-row');
      id = element.data('id');
      name = element.data('action');
      params = this._extraParams();
      ids = String(id).split(',');
      count = ids.length;
      if (ids.length > 1) {
        promises = _.map(ids, function(singleId) {
          return serviceCall('nodeway', "notifications/" + (core.getCurrentUserid()) + "/" + singleId, 'DELETE', params);
        });
        return $.when.apply($, promises).done(function() {
          return _this.trigger('event:removed', element, {
            name: name,
            id: id,
            count: count
          });
        });
      } else {
        promise = serviceCall('nodeway', "notifications/" + (core.getCurrentUserid()) + "/" + id, 'DELETE', params);
        return promise.done(function() {
          return _this.trigger('event:removed', element, {
            name: name,
            id: id,
            count: 1
          });
        });
      }
    };

    ClientsEventsView.prototype.decreaseGroupCounter = function(name, value) {
      var counter;
      counter = this.getCounterValue(name);
      return this.setCounterValue(name, counter - value);
    };

    ClientsEventsView.prototype.getCounterValue = function(name) {
      return parseInt(this.$el.find(".clients-event-group-counter[data-group-name*='" + name + "']").text());
    };

    ClientsEventsView.prototype.setCounterValue = function(name, value) {
      return this.$el.find(".clients-event-group-counter[data-group-name*='" + name + "']").text(value);
    };

    /* Formatting functions for the top-level (grouped) items
    */


    ClientsEventsView.prototype.formatGroupName = function(id) {
      var metadata, predefinedName;
      predefinedName = (function() {
        switch (id) {
          case 'feed.comment.transaction':
            return 'You have unread comments on transactions';
          case 'feed.message.created':
            return 'You have unread messages';
          case 'feed.message.edited':
            return 'You have updated messages';
          case 'feed.comment.page_dashboard':
            return 'You have unread messages';
          case 'feed.comment.page_info':
            return 'You have unread messages';
          case 'feed.dp.statement.processed':
            return 'New processed statements available';
          case 'feed.fds.rec_file_created':
            return 'New Bank Connection statements available';
          case 'event.stripe.created':
            return 'Stripe Merchant Files';
          case 'event.stripe.error':
            return 'Stripe Merchant Errors';
          case 'event.square.document_created':
            return 'Square Merchant Files';
          case 'event.square.document_upload_failed':
            return 'Square Merchant Errors';
          case 'event.categorization.responded':
            return 'You have categorization notes';
          case 'event.categorization.selected':
            return 'Categorization suggestions accepted';
          case 'feed.fds.ledger_permanent_unbalanced':
            return 'Invalid Balances from Bank Feed';
          case 'feed.fds.account_established':
            return 'New account available';
          case 'feed.fds.account_inactive':
            return 'Account has become inactive';
          case 'feed.fds.connection_established':
            return 'New bank connection established';
          case 'feed.fds.connection_failed':
            return 'You have financial data connection errors';
          case 'feed.autopost.succeeded':
            return 'New statements were auto-posted successfully';
          case 'feed.autopost.failed':
            return 'Statements failed to auto-post';
          case 'event.account_monthly.updated':
            return 'Accounts were auto-posted';
          case 'feed.fds.account_usage_type_changed':
            return 'Account type changed';
          case 'feed.fds.pb_account_created':
            return 'New account available';
          case 'event.work_management.client.resolved.task':
            return 'Client resolved tasks';
          case 'feed.client.company_details_updated':
            return 'Company details updated';
        }
      })();
      if (predefinedName) {
        return predefinedName;
      } else {
        metadata = _.findWhere(eventsMetadata, {
          id: id
        });
        if (metadata) {
          metadata.description.replace('{{client}}', 'Client');
          return metadata.description.replace('{{clientURL}}', 'Client');
        } else {
          return '';
        }
      }
    };

    /* Formatting functions for the list of notifications
    */


    ClientsEventsView.prototype.formatDescription = function(event) {
      var client, link, name;
      client = event.client;
      name = "" + client.company + " (" + client.fullName + ")";
      link = "<a href='" + (core.getImpersonatedURL(client.id)) + "'>" + (this.sanitize(name)) + "</a>";
      event.description = event.description.replace("{{clientURL}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatTransactionCommentDescription = function(event) {
      var client, docType, itemId, link, url, urlText, _ref;
      client = event.client;
      docType = this._findPayloadValueByName('docType', event);
      itemId = this._findPayloadValueByName('itemId', event);
      _ref = docType === 'je' ? ['transaction-manager?tab=FOLLOW_UP', 'transaction #' + itemId] : ['unmatched-receipts-search/id:' + itemId, 'document #' + itemId], url = _ref[0], urlText = _ref[1];
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + urlText + "</a>";
      event.description = event.description.replace("{{itemURL}}", link);
      return event;
    };

    monthNumericToText = function(monthNum) {
      var lookup;
      lookup = {
        0: "Jan",
        1: "Feb",
        2: "Mar",
        3: "Apr",
        4: "May",
        5: "Jun",
        6: "Jul",
        7: "Aug",
        8: "Sep",
        9: "Oct",
        10: "Nov",
        11: "Dec"
      };
      return lookup[monthNum] || monthNum;
    };

    ClientsEventsView.prototype.formatDataProcessingDescription = function(event) {
      var client, closeDate, ledgerId, ledgerName, link, openDate, statementDate, statementMonth, statementTimestamp, statementYear, url, urlText, _ref;
      client = event.client;
      statementTimestamp = parseInt(this._findPayloadValueByName('statementTimestamp', event));
      statementMonth = this._findPayloadValueByName('statementMonth', event);
      statementYear = this._findPayloadValueByName('statementYear', event);
      if (statementTimestamp) {
        statementDate = new Date(statementTimestamp * 1000);
        statementYear = statementDate.getFullYear();
        statementMonth = monthNumericToText(statementDate.getMonth());
      } else if (!isNaN(statementMonth)) {
        closeDate = Date.parse(this._findPayloadValueByName('statementClosingDate', event));
        openDate = Date.parse(this._findPayloadValueByName('statementOpeningDate', event));
        if (closeDate) {
          statementMonth = monthNumericToText(closeDate.getMonth());
        } else if (openDate) {
          statementMonth = monthNumericToText(openDate.getMonth() + 1);
        }
      }
      ledgerId = this._findPayloadValueByName('ledgerId', event);
      ledgerName = this._findPayloadValueByName('ledgerName', event);
      _ref = ["new-folders/statements/" + statementYear + "/ledger/" + ledgerId, "" + statementMonth + " " + statementYear + " statement"], url = _ref[0], urlText = _ref[1];
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + urlText + "</a>";
      event.description = event.description.replace("{{itemURL}}", link);
      if (ledgerName != null) {
        event.description = event.description.replace("{{ledger}}", ledgerName);
      }
      return event;
    };

    ClientsEventsView.prototype.formatFDSStatementDescription = function(event) {
      var client, ledgerName, link, openDate, openTimestamp, statementId, statementMonth, statementYear, url;
      client = event.client;
      ledgerName = this._findPayloadValueByName('ledgerName', event);
      if (ledgerName != null) {
        event.description = event.description.replace("{{ledger}}", ledgerName);
      }
      openTimestamp = this._findPayloadValueByName('statementOpeningDate', event);
      if (openTimestamp) {
        openDate = new Date(openTimestamp * 1000);
        statementYear = openDate.getUTCFullYear();
        statementMonth = monthNumericToText(openDate.getUTCMonth());
        event.description = event.description.replace("{{year}}", statementYear);
        event.description = event.description.replace("{{month}}", statementMonth);
      }
      statementId = this._findResourceValueByName('account_statement', event);
      url = 'reconciliation/' + statementId;
      link = "<a href=\"" + (core.getImpersonatedURL(client.id, url)) + "\">Bank Feed Transactions</a>";
      event.description = event.description.replace("{{recURL}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatJENotificationDescription = function(event) {
      var client, itemId, link, url, urlText, _ref;
      client = event.client;
      itemId = this._findResourceValueByName('document', event);
      _ref = ['document-entry/' + itemId, 'transaction #' + itemId], url = _ref[0], urlText = _ref[1];
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + urlText + "</a>";
      event.description = event.description.replace("{{itemURL}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatPageCommentDescription = function(event) {
      var attachedTo, client, conversationId, link, linkName, url;
      client = event.client;
      conversationId = this._findResourceValueByName('conversation', event);
      attachedTo = this._findPayloadValueByName('itemId', event);
      conversationId = conversationId ? '#' + conversationId : '';
      linkName = (function() {
        switch (attachedTo) {
          case 'info':
            return 'card';
          default:
            return attachedTo;
        }
      })();
      url = linkName + conversationId;
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + linkName + "</a>";
      event.description = event.description.replace("{{itemURL}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatMessageFeedDescription = function(event) {
      var client, link, url;
      client = event.client;
      url = 'new-dashboard';
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>message feed (Bench 2.0)</a>";
      event.description = event.description.replace("{{itemURL}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatCategorizationNotesDescription = function(event) {
      var client, itemId, link, tab, url, urlText, _ref;
      client = event.client;
      tab = this._findPayloadValueByName('tab', event || 'FOLLOW_UP');
      itemId = tab === 'FOLLOW_UP' ? this._findResourceValueByName('document', event) : this._findPayloadValueByName('itemId', event);
      _ref = ["transaction-manager?tab=" + tab, 'transaction #' + itemId], url = _ref[0], urlText = _ref[1];
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + urlText + "</a>";
      event.description = event.description.replace("{{itemURL}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatCategorizationSelectionDescription = function(event) {
      var client, itemId, ledgerEl, ledgerName, link, url, vendor;
      client = event.client;
      itemId = this._findResourceValueByName('document', event);
      vendor = this._findResourcePayloadByName('document', event);
      ledgerName = this._findPayloadValueByName('ledgerName', event);
      url = "search/id:" + itemId;
      link = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + vendor + "</a>";
      ledgerEl = "<b>" + ledgerName + "</b>";
      event.description = event.description.replace("{{itemURL}}", link);
      event.description = event.description.replace("{{ledgerName}}", ledgerEl);
      return event;
    };

    ClientsEventsView.prototype.formatFDSErrorDescription = function(event) {
      var accountsLink, client;
      client = event.client;
      this._replaceEventDescriptionWithPayload('bank', "{{bank}}", event);
      this._replaceEventDescriptionWithPayload('ledgerName', "{{ledger}}", event);
      accountsLink = "<a href=\"/app/" + client.id + "/accounts\">connection</a>";
      event.description = event.description.replace("{{accountsLink}}", accountsLink);
      return event;
    };

    ClientsEventsView.prototype.formatStripeorSquareDescription = function(event) {
      var downloadLink, fileId, fileName;
      switch (event.name) {
        case 'event.stripe.created':
        case 'event.square.document_created':
          fileId = this._findPayloadValueByName('fileId', event);
          fileName = this._findPayloadValueByName('fileName', event);
          downloadLink = "<a href=\"" + location.apiRoot + "/api/v1/file.json/" + fileId + "/download\" target=\"_blank\">ready to download</a>";
          event.description = event.description.replace("{{fileName}}", fileName);
          event.description = event.description.replace("{{downloadLink}}", downloadLink);
      }
      return event;
    };

    ClientsEventsView.prototype.formatFDSPermanentUnbalanced = function(event) {
      var ledger, ledgerAccountName, ledgerId;
      ledgerId = this._findPayloadValueByName('ledgerId', event);
      ledgerAccountName = "One";
      ledger = core.getCollection('ledgerAccounts').find(function(account) {
        return account.id === ledgerId;
      });
      if (ledger) {
        ledgerAccountName = ledger.attributes.name;
      }
      event.description = event.description.replace("{{ledgerAccountName}}", "<b>" + ledgerAccountName + "</b>");
      return event;
    };

    ClientsEventsView.prototype.formatFDSAccountEstablished = function(event) {
      var accountText, client, link, pageId, sourceAsset, _ref;
      client = event.client;
      pageId = 'accounts';
      sourceAsset = (_ref = event.assets) != null ? _ref.find(function(asset) {
        return asset.assetType === 'payload' && asset.payloadName === 'source';
      }) : void 0;
      accountText = "bank account";
      if (sourceAsset != null) {
        accountText = "" + sourceAsset.payload + " account";
      }
      link = "<a href='" + (core.getImpersonatedURL(client.id, pageId)) + "'>" + accountText + "</a>";
      event.description = event.description.replace("{{accountsLink}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatPBAccountEstablished = function(event) {
      var client, link, pageId, personalBusinessAccounts;
      client = event.client;
      personalBusinessAccounts = this._findPayloadValueByName('newPersonalBusinessAccounts', event);
      pageId = 'accounts';
      link = "<a href='" + (core.getImpersonatedURL(client.id, pageId)) + "'>account</a>";
      event.description = event.description.replace("{{accountsLink}}", link);
      event.description = event.description.replace("{{personalBusinessAccounts}}", personalBusinessAccounts);
      return event;
    };

    ClientsEventsView.prototype.formatFDSAccountInactive = function(event) {
      var client, link, pageId;
      client = event.client;
      pageId = 'accounts';
      link = "<a href='" + (core.getImpersonatedURL(client.id, pageId)) + "'>accounts</a>";
      event.description = event.description.replace("{{accountsLink}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatFDSConnectionCreated = function(event) {
      var client, link, pageId;
      client = event.client;
      pageId = 'accounts';
      link = "<a href='" + (core.getImpersonatedURL(client.id, pageId)) + "'>connection</a>";
      event.description = event.description.replace("{{accountsLink}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatFDSAccountUsageTypeChanged = function(event) {
      var accountName, client, clientUsageType, link, pageId;
      client = event.client;
      pageId = 'accounts';
      link = "<a href='" + (core.getImpersonatedURL(client.id, pageId)) + "'>connection</a>";
      accountName = this._findPayloadValueByName('accountName', event);
      clientUsageType = this._findPayloadValueByName('clientUsageType', event);
      event.description = event.description.replace("{{accountName}}", accountName);
      event.description = event.description.replace("{{clientUsageType}}", clientUsageType);
      event.description = event.description.replace("{{accountsLink}}", link);
      return event;
    };

    ClientsEventsView.prototype.formatAccountMonthlyUpdated = function(event) {
      var accountMonthlyUpdatedEvents, accountName, date, eventDescription, formattedDate, newStatus, prevStatus, yearMonth;
      newStatus = this._findPayloadValueByName('newStatus', event);
      yearMonth = this._findPayloadValueByName('yearMonth', event);
      accountName = this._findPayloadValueByName('accountName', event);
      accountMonthlyUpdatedEvents = _.reduce(eventsMetadata, function(acc, data) {
        if (data.id === 'event.account_monthly.updated_complete' || data.id === 'event.account_monthly.updated_ready_for_work' || data.id === 'event.account_monthly.pb_updated') {
          acc[data.id] = data.description;
        }
        return acc;
      }, {});
      eventDescription;
      switch (newStatus) {
        case 'COMPLETE':
          eventDescription = accountMonthlyUpdatedEvents['event.account_monthly.updated_complete'];
          break;
        case 'READY_FOR_WORK':
          eventDescription = accountMonthlyUpdatedEvents['event.account_monthly.updated_ready_for_work'];
          break;
        case 'AWAITING_PB_ACTION_BY_CLIENT':
          eventDescription = accountMonthlyUpdatedEvents['event.account_monthly.pb_updated'];
          break;
        default:
          console.error("No handling for newStatus: " + newStatus + " has been implemented.");
      }
      date = new Date(yearMonth.replace("-", "/"));
      formattedDate = dateFns.format(date, "MMMM YYYY");
      if (newStatus === 'AWAITING_PB_ACTION_BY_CLIENT') {
        prevStatus = this._findPayloadValueByName('prevStatus', event);
        eventDescription = eventDescription.replace("{{prevStatus}}", prevStatus);
        eventDescription = eventDescription.replace("{{newStatus}}", newStatus);
      }
      event.description = eventDescription;
      event.description = event.description.replace("{{yearMonth}}", formattedDate);
      event.description = event.description.replace("{{accountName}}", accountName);
      return event;
    };

    ClientsEventsView.prototype.formatClientResolvedTaskDescription = function(event) {
      var taskType;
      taskType = this._findPayloadValueByName('taskType', event);
      event.taskType = taskType || 'unknown';
      return event;
    };

    ClientsEventsView.prototype.formatAutoPostSucceeded = function(event) {
      var client, closingDateLastDayOfMonthString, firstDayOfMonth, lastDayOfMonth, ledgerName, openingDateFirstDayOfMonthString, statementClosingTimestamp, statementDateText, statementEndDate, statementEndMonth, statementEndYear, statementLink, statementOpeningDate, statementOpeningTimestamp, statementStartMonth, statementStartYear, url, urlText;
      client = event.client;
      statementOpeningTimestamp = parseInt(this._findPayloadValueByName('statementOpeningDate', event));
      statementClosingTimestamp = parseInt(this._findPayloadValueByName('statementClosingDate', event));
      if (statementOpeningTimestamp) {
        statementOpeningDate = new Date(statementOpeningTimestamp * 1000);
        statementStartYear = statementOpeningDate.getUTCFullYear();
        statementStartMonth = monthNumericToText(statementOpeningDate.getUTCMonth());
        firstDayOfMonth = String(statementOpeningDate.getUTCMonth() + 1).padStart(2, '0');
        openingDateFirstDayOfMonthString = "" + statementStartYear + "-" + firstDayOfMonth + "-01";
      }
      if (statementClosingTimestamp) {
        statementEndDate = new Date(statementClosingTimestamp * 1000);
        statementEndMonth = monthNumericToText(statementEndDate.getUTCMonth());
        statementEndYear = statementEndDate.getUTCFullYear();
        lastDayOfMonth = new Date(Date.UTC(statementEndDate.getUTCFullYear(), statementEndDate.getUTCMonth() + 1, 0));
        closingDateLastDayOfMonthString = lastDayOfMonth.toISOString().split('T')[0];
      }
      if (statementStartMonth === statementEndMonth) {
        statementDateText = "" + statementEndMonth + " " + statementEndYear;
      } else {
        statementDateText = "" + statementStartMonth + " " + statementStartYear + " to " + statementEndMonth + " " + statementEndYear;
      }
      ledgerName = this._findPayloadValueByName('ledgerName', event);
      url = "general-ledger?startDate=" + openingDateFirstDayOfMonthString + "&endDate=" + closingDateLastDayOfMonthString;
      urlText = statementClosingTimestamp ? "" + statementDateText + " file" : "File";
      statementLink = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + urlText + "</a>";
      event.description = event.description.replace("{{statementLink}}", statementLink);
      if (ledgerName) {
        event.description = event.description.replace("{{ledger}}", ledgerName);
      } else {
        event.description = event.description.replace("{{ledger}}", 'Unknown Ledger');
      }
      return event;
    };

    ClientsEventsView.prototype.formatAutoPostFailed = function(event) {
      var client, errorMessageText, ledgerName, resourceId, statementClosingTimestamp, statementDateText, statementEndDate, statementEndMonth, statementEndYear, statementLink, statementOpeningTimestamp, statementStartDate, statementStartMonth, statementStartYear, url, urlText, validationError, validationErrorMessage;
      client = event.client;
      resourceId = this._findResourceValueByName('account_statement', event);
      statementOpeningTimestamp = parseInt(this._findPayloadValueByName('statementOpeningDate', event));
      statementClosingTimestamp = parseInt(this._findPayloadValueByName('statementClosingDate', event));
      if (statementOpeningTimestamp) {
        statementStartDate = new Date(statementOpeningTimestamp * 1000);
        statementStartMonth = monthNumericToText(statementStartDate.getUTCMonth());
        statementStartYear = statementStartDate.getUTCFullYear();
      }
      if (statementClosingTimestamp) {
        statementEndDate = new Date(statementClosingTimestamp * 1000);
        statementEndMonth = monthNumericToText(statementEndDate.getUTCMonth());
        statementEndYear = statementEndDate.getUTCFullYear();
      }
      if (statementStartMonth === statementEndMonth) {
        statementDateText = "" + statementEndMonth + " " + statementEndYear;
      } else {
        statementDateText = "" + statementStartMonth + " " + statementStartYear + " to " + statementEndMonth + " " + statementEndYear;
      }
      ledgerName = this._findPayloadValueByName('ledgerName', event);
      validationError = _.filter(event.assets, function(asset) {
        return asset.payloadName && asset.payloadName.includes('validationError');
      });
      validationErrorMessage = _.map(validationError, function(error) {
        return error.payload;
      });
      errorMessageText = validationErrorMessage.join(' ');
      if (validationError) {
        event.description = event.description.replace("{{validationError}}", errorMessageText);
      } else {
        event.description = event.description.replace("{{validationError}}", 'Unknown Error');
      }
      url = "reconciliation/" + resourceId;
      urlText = statementClosingTimestamp ? "" + statementDateText + " file" : "File";
      statementLink = "<a href='" + (core.getImpersonatedURL(client.id, url)) + "'>" + urlText + "</a>";
      event.description = event.description.replace("{{statementLink}}", statementLink);
      if (ledgerName) {
        event.description = event.description.replace("{{ledger}}", ledgerName);
      } else {
        event.description = event.description.replace("{{ledger}}", 'Unknown Ledger');
      }
      return event;
    };

    ClientsEventsView.prototype.preprocessEvents = function(events, group) {
      var filteredEvents, userRoles,
        _this = this;
      if (group == null) {
        group = true;
      }
      userRoles = core.getCurrentClientRoles();
      _.each(events, function(event) {
        var client, comment, message, metadata;
        client = _this.findClientDataById(event.context.personId);
        event.client = client;
        metadata = _.find(eventsMetadata, function(data) {
          var rolesMatched, skipRoles, _ref;
          _ref = data.roles ? [false, _.intersection(userRoles, data.roles).length === userRoles.length] : [true, null], skipRoles = _ref[0], rolesMatched = _ref[1];
          return (data != null ? data.id : void 0) === event.name && (!skipRoles ? rolesMatched : true);
        });
        if (!metadata) {
          return;
        }
        event.description = metadata.description;
        comment = _this._findPayloadValueByName('comment', event);
        if (comment) {
          event.snippet = _this._createCommentSnippet(comment);
        }
        message = _this._findPayloadValueByName('message', event);
        if (message) {
          event.snippet = _this._createCommentSnippet(message);
        }
        event = _this.formatDescription(event);
        return event = (function() {
          switch (event.name) {
            case 'feed.comment.transaction':
              return this.formatTransactionCommentDescription(event);
            case 'feed.dp.statement.processed':
            case 'feed.dp.statement.rejected':
              return this.formatDataProcessingDescription(event);
            case 'feed.fds.rec_file_created':
              return this.formatFDSStatementDescription(event);
            case 'feed.datachecker.je_empty_vendor':
            case 'feed.datachecker.de_zero_based':
            case 'feed.datachecker.je_no_des':
              return this.formatJENotificationDescription(event);
            case 'feed.comment.page_info':
            case 'feed.comment.page_dashboard':
              return this.formatPageCommentDescription(event);
            case 'feed.message.created':
            case 'feed.message.edited':
              return this.formatMessageFeedDescription(event);
            case 'feed.fds.connection_failed':
              return this.formatFDSErrorDescription(event);
            case 'feed.fds.ledger_permanent_unbalanced':
              return this.formatFDSPermanentUnbalanced(event);
            case 'feed.fds.account_established':
              return this.formatFDSAccountEstablished(event);
            case 'feed.fds.account_inactive':
              return this.formatFDSAccountInactive(event);
            case 'feed.fds.connection_established':
              return this.formatFDSConnectionCreated(event);
            case 'event.stripe.created':
            case 'event.stripe.error':
            case 'event.square.document_created':
            case 'event.square.document_upload_failed':
              return this.formatStripeorSquareDescription(event);
            case 'event.categorization.responded':
              return this.formatCategorizationNotesDescription(event);
            case 'event.categorization.selected':
              return this.formatCategorizationSelectionDescription(event);
            case 'feed.autopost.succeeded':
              return this.formatAutoPostSucceeded(event);
            case 'feed.autopost.failed':
              return this.formatAutoPostFailed(event);
            case 'event.account_monthly.updated':
              return this.formatAccountMonthlyUpdated(event);
            case 'feed.fds.account_usage_type_changed':
              return this.formatFDSAccountUsageTypeChanged(event);
            case 'feed.fds.pb_account_created':
              return this.formatPBAccountEstablished(event);
            case 'event.work_management.client.resolved.task':
              return this.formatClientResolvedTaskDescription(event);
            default:
              return event;
          }
        }).call(_this);
      });
      filteredEvents = _.filter(events, function(event) {
        return event.description;
      });
      if (group) {
        return _.groupBy(filteredEvents, function(event) {
          return event.name;
        });
      } else {
        return filteredEvents;
      }
    };

    ClientsEventsView.prototype._extraParams = function(params) {
      var extraParams;
      if (core.isCurrentClientBookkeeper()) {
        extraParams = {
          group: 'BENCH'
        };
      } else {
        extraParams = {};
      }
      if (params) {
        extraParams = _.extend(extraParams, params);
      }
      return extraParams;
    };

    ClientsEventsView.prototype._buildUrlParams = function(userId, filters, extraParams) {
      var params;
      params = filters ? (filters['useFilters'] = true, filters) : {
        cids: userId
      };
      params = _.extend(params, this._extraParams(extraParams));
      return $.param(params);
    };

    ClientsEventsView.prototype.getEvents = function(userId, filter, mode, callback) {
      var promise, urlParams;
      urlParams = this._buildUrlParams(userId, filter);
      promise = serviceCall('nodeway', "notifications/" + mode + "/" + (core.getCurrentUserid()) + "?full=true&" + urlParams);
      return promise.done(function(data) {
        return typeof callback === "function" ? callback(data) : void 0;
      });
    };

    ClientsEventsView.prototype.getPaginatedEventsByName = function(userId, filter, mode, eventNames, eventsLimit, beforeTimestamp, callback) {
      var extraParams, promise, urlParams;
      extraParams = {
        names: eventNames
      };
      if (eventsLimit) {
        extraParams.limit = eventsLimit;
      }
      if (beforeTimestamp) {
        extraParams.before = beforeTimestamp;
      }
      urlParams = this._buildUrlParams(userId, filter, extraParams);
      promise = serviceCall('nodeway', "notifications/" + mode + "/" + (core.getCurrentUserid()) + "?full=true&" + urlParams);
      return promise.done(function(data) {
        return typeof callback === "function" ? callback(data) : void 0;
      });
    };

    ClientsEventsView.prototype.getEventsStats = function(userId, filter, mode, callback) {
      var promise, urlParams;
      urlParams = this._buildUrlParams(userId, filter);
      promise = serviceCall('nodeway', "notifications/" + mode + "/" + (core.getCurrentUserid()) + "?stats=true&" + urlParams);
      return promise.done(function(data) {
        return typeof callback === "function" ? callback(data) : void 0;
      });
    };

    ClientsEventsView.prototype.getEventsStatsByName = function(userId, filter, mode, eventNames, callback) {
      var promise, urlParams;
      urlParams = this._buildUrlParams(userId, filter, {
        names: eventNames
      });
      promise = serviceCall('nodeway', "notifications/" + mode + "/" + (core.getCurrentUserid()) + "?stats=true&full=false&preview=true&" + urlParams);
      return promise.done(function(data) {
        return typeof callback === "function" ? callback(data) : void 0;
      });
    };

    ClientsEventsView.prototype.trackRemoval = function(e, global) {
      var element, event, groupName, timeToRemove, timestamp;
      element = $(e.currentTarget).closest('.clients-event-row');
      groupName = element.data('action');
      timestamp = element.data('timestamp');
      timeToRemove = Math.floor((new Date().getTime() - timestamp) / 1000);
      event = global ? 'Global Notification Removed' : 'Client Notification Removed';
      return core.trackEvent(event, {
        'event': groupName,
        'time_to_remove': timeToRemove
      });
    };

    ClientsEventsView.prototype.trackNavigation = function(e, global) {
      var element, event, groupName;
      element = $(e.currentTarget).closest('.clients-event-row');
      groupName = element.data('action');
      event = global ? 'Global Notification Clicked' : 'Client Notification Clicked';
      return core.trackEvent(event, {
        'event': groupName
      });
    };

    ClientsEventsView.prototype._replaceEventDescriptionWithPayload = function(payloadName, description, event) {
      var payloadValue;
      payloadValue = this._findPayloadValueByName(payloadName, event);
      if (payloadValue != null) {
        return event.description = event.description.replace(description, payloadValue);
      }
    };

    ClientsEventsView.prototype._findPayloadValueByName = function(payloadName, event) {
      var _ref;
      return (_ref = _.findWhere(event.assets, {
        assetType: 'payload',
        payloadName: payloadName
      })) != null ? _ref.payload : void 0;
    };

    ClientsEventsView.prototype._findResourceValueByName = function(resourceType, event) {
      var _ref;
      return (_ref = _.findWhere(event.assets, {
        assetType: 'resource',
        resource: resourceType
      })) != null ? _ref.resourceId : void 0;
    };

    ClientsEventsView.prototype._findResourcePayloadByName = function(resourceType, event) {
      var _ref;
      return (_ref = _.findWhere(event.assets, {
        assetType: 'resource',
        resource: resourceType
      })) != null ? _ref.payload : void 0;
    };

    ClientsEventsView.prototype._createCommentSnippet = function(comment) {
      if (comment.length > 140) {
        return comment.substring(0, 137) + "...";
      } else {
        return comment;
      }
    };

    return ClientsEventsView;

  })(Backbone.View);
});
